const abortedErrors = [
    'query() call aborted',
    'queryRoute() call aborted',
    'throwStaticHandlerAbortedError',
];

export const ignoreErrorsFullstack = [...abortedErrors];
export const ignoreErrorsFrontend = [];
export const ignoreErrorsBackend = [];
